import { StaticImageData } from 'next/image';
import imgMac from './assets/mt5-mac.svg';
import imgWindows from './assets/mt5-windows.svg';
import imgIos from './assets/mt5-ios.svg';
import imgAndroid from './assets/mt5-android.svg';
import imgWeb from './assets/mt5-web.svg';

export type Device = 'mac' | 'windows' | 'ios' | 'android' | 'web';

export function getMetaTraderDevices(): Device[] {
  return ['mac', 'windows', 'ios', 'android', 'web'];
}

export const heroImages: Record<Device, StaticImageData> = {
  mac: imgMac,
  windows: imgWindows,
  ios: imgIos,
  android: imgAndroid,
  web: imgWeb,
};
